<template>
  <div>
    {{ equipmentDescription }}
  </div>
</template>

<script>
export default {
  name: 'EquipmentCellRenderer',
  data() {
    return {
      isContractual: null,
      equipmentCode: null
    }
  },
  computed : {
    equipmentDescription() {
      if (this.equipmentCode === null) {
        return null;
      }
      else {
        const equipment = this.params.context.componentParent.equipments.find(e => e.code === this.equipmentCode && e.isContractual === this.isContractual)
        if (equipment) {
          let description = equipment.code;
          if (equipment.isContractual)
            description += "(C)";

          return description;
        }
        else {
          let description = this.equipmentCode;
          if (this.isContractual)
            description += "(C)";
            
          return description;
        }
      }
    }
  },
  created() {
    this.isContractual = this.params.value.isContractual;
    this.equipmentCode = this.params.value.equipmentCode;
 
  }
}
</script>
